import {firebaseApp} from './app';
import { getMessaging } from "firebase/messaging";

export const messaging = getMessaging(firebaseApp);

export function getMessagingObject() {
    // [START messaging_get_messaging_object]
    return messaging
    // [END messaging_get_messaging_object]
  }